import tick from '~/assets/icons/tick.svg';
import { CurrencyIcon } from '~/components/collections';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import {
	StyledBottomContainer,
	StyledComplete,
	StyledContainer,
	StyledRewardContainer,
	StyledRewardsContainer,
	StyledTaskText,
	StyledTopContainer,
	StyledXPStar,
} from './Task.styled';

interface ITaskProps extends React.HTMLAttributes<HTMLDivElement> {
	name: string;
	text: string;
	exp: number;
	amount: number;
	progress: number;
}

const Task: React.FC<ITaskProps> = ({
	name,
	text,
	exp,
	amount,
	progress,
}: ITaskProps) => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<StyledContainer $complete={progress === 100}>
			{/* <StyledBackground $progress={progress} /> */}
			<StyledTopContainer>
				<Text style={{ fontSize: '16px', fontWeight: 700, color: '#FFFFFF' }}>
					{name}
				</Text>
				<div>
					{/* <StyledStar
						$pinned={pinned}
						onMouseEnter={() => {
							setPopupVisible(true);
							playSound(Sound.LinkCursor);
						}}
						onMouseLeave={() => setPopupVisible(false)}
					/> */}
					{/* <CSSTransition
						in={popupVisible}
						classNames={'popup'}
						timeout={500}
						unmountOnExit
					>
						<StyledPopup
							text={pinned ? 'Открепить задачу' : 'Закрепить задачу'}
						/>
					</CSSTransition> */}
				</div>
			</StyledTopContainer>
			<StyledTaskText>{text}</StyledTaskText>
			<StyledBottomContainer>
				<Text
					style={{
						fontSize: '16px',
						fontWeight: 400,
						color: '#FFFFFF',
						opacity: 0.25,
					}}
				>
					Награда
				</Text>
				<StyledRewardsContainer>
					<StyledRewardContainer>
						<Text style={{ color: '#FFB500' }}>
							{exp.toLocaleString('ru-RU')}
						</Text>
						<StyledXPStar />
					</StyledRewardContainer>
					<StyledRewardContainer>
						<Text style={{ color: '#FFFFFF' }}>
							{amount.toLocaleString('ru-RU')}
						</Text>
						<CurrencyIcon icon={rubleIcon} size="sm" />
					</StyledRewardContainer>
				</StyledRewardsContainer>
			</StyledBottomContainer>
			{progress === 100 && (
				<StyledComplete>
					<img src={tick} />
					<Text>Задача выполнена</Text>
				</StyledComplete>
			)}
		</StyledContainer>
	);
};

export { Task };
